import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function IconListRender({ node }) {
  const content = node.content || {};
  
  // Da die Struktur dynamisch als JSON-String gespeichert wird (weil Custom Arrays im DesignerInspector komplizierter sind)
  // nutzen wir vorerst eine kommaseparierte Liste für einfache Items.
  const rawItems = content.items || 'Feature 1, Feature 2, Feature 3';
  const items = rawItems.split(',').map(s => s.trim()).filter(Boolean);
  
  const icon = content.icon || '✓';
  const iconColor = content.iconColor || '#10b981'; // Grün als Standard-Check
  const textColor = content.textColor || '#cbd5e1';
  const gap = content.gap || '12px';

  return (
    <ul style={{ 
      listStyle: 'none', 
      padding: 0, 
      margin: 0, 
      display: 'flex', 
      flexDirection: 'column', 
      gap: gap,
      width: '100%'
    }}>
      {items.map((item, idx) => (
        <li key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <span style={{ 
            color: iconColor, 
            display: 'inline-flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            minWidth: '20px',
            marginTop: '2px' // Leichte Korrektur für bessere Baseline-Ausrichtung zu Text
          }}>
            {icon}
          </span>
          <span style={{ color: textColor, lineHeight: '1.5' }}>
            {item}
          </span>
        </li>
      ))}
    </ul>
  );
}

registry.register('IconList', {
  label: 'Icon-Liste',
  icon: '📋', 
  category: 'basic',
  component: IconListRender,
  
  defaultProps: {
    content: {
      items: 'Kostenloses Roaming, 5G inklusive, EU-Weite Flatrate, Anschlusspreisbefreiung',
      icon: '✓',
      iconColor: '#10b981',
      textColor: '#cbd5e1',
      gap: '12px'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Listen-Einträge',
          fields: [
            { name: 'content.items', label: 'Punkte (Kommasepariert)', type: 'text' }
          ]
        },
        {
          title: 'Styling',
          fields: [
            { name: 'content.icon', label: 'Listen-Icon (Emoji)', type: 'text' },
            { name: 'content.iconColor', label: 'Icon Farbe', type: 'color' },
            { name: 'content.textColor', label: 'Text Farbe', type: 'color' },
            { name: 'content.gap', label: 'Abstand zwischen Punkten', type: 'text' }
          ]
        }
      ]
    }
  ]
});
